/**
 * Purpose: This middleware builds and sets the latest offer payload object in memory. Add redux actions to the validActions array when those actions should update the payload.
 */
import { type ReduxNext } from '@makemydeal/dr-shared-store';
import {
    checkNoDealAssociatedWithDealerships,
    CLEAR_ROLE_ASSUMPTION,
    SAVE_ROLE_ASSUMPTED_USERNAME
} from '@makemydeal/dr-activities-role-assumption';
import { navigateTo } from '@makemydeal/dr-activities-common';
import { RouteValues } from '../routeConstants';
import { dealershipSelectors, fetchDealerships } from '@makemydeal/dr-activities-dealership-picker';
import { NAVIGATE_TO_DASHBOARD } from '../actionTypes/roleAssumptionActionTypes';
import { resetOpenDeal } from '../actions/roleAssumptionActionCreators';

export const middleware = (store: any) => (next: ReduxNext) => (action: any) => {
    next(action);
    switch (action.type) {
        case SAVE_ROLE_ASSUMPTED_USERNAME: {
            sessionStorage.setItem('role-assumption', action.userName);
            // Clear any previous "no deal associated" state
            store.dispatch(checkNoDealAssociatedWithDealerships(false));
            break;
        }
        case CLEAR_ROLE_ASSUMPTION: {
            sessionStorage.removeItem('role-assumption');
            const state = store.getState();
            if (state.dealValidation.valid || Object.keys(state.dealValidation).length === 0) {
                return store.dispatch(navigateTo(RouteValues.DASHBOARD));
            }
            store.dispatch(resetOpenDeal());
            store.dispatch(navigateTo(RouteValues.ROLE_ASSUMPTION));
            break;
        }
        case NAVIGATE_TO_DASHBOARD: {
            const state = store.getState();
            const { getDealershipURL } = dealershipSelectors.additionalSelectors;
            const bffEndpoint = getDealershipURL(state);
            if (bffEndpoint) {
                store.dispatch(fetchDealerships(bffEndpoint));
            }
            break;
        }

        default: {
            break;
        }
    }
};
